module.exports = __webpack_public_path__ + "static/media/eye-icon-form.5a302a0b.svg";